module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon_tick-ab970c7c45c2196ea44ae1b15a85ab34.svg";